export const SESSION_EXPIRED_EVENT = 'ci:session-expired';

export const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
};

export const expireSession = (token) => {
  // A delayed 401 from an old session must not sign out a newer login.
  if (localStorage.getItem('token') !== token) return;
  clearSession();
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};
